var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecayCap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M505.065 3H8.5V328.174M505.065 3V328.174H8.5M505.065 3L521.5 19.4348V344.608H24.9348L8.5 328.174",
    stroke: "#65D1FF",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 328.174L25 344.608H521.5L505.065 328.174H9Z",
    fill: "#0099BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521.5 344.608V19.4348L505.065 3V328.174L521.5 344.608Z",
    fill: "#65D1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M368.544 171.698V197.524H299.87H231.196H145.5V171.698H257.022H325.696H368.544Z",
    fill: "#65D1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 368V345H521.926V0H545V368H0.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecayCap);
export default __webpack_public_path__ + "static/media/decay-cap.6ae751bd370d8c9dd60501758efa77cd.svg";
export { ForwardRef as ReactComponent };